import { useEffect, useState } from 'react'
import { api } from 'core/api/ConnectionManager'
import { ISelectedInfo } from '../__info/displays__info.local.methods'
import { IRecordWithStrings } from '../../../core/helpers'
import type { ISelectedItems } from './displays__toolbarContent'
import type { IDisplaysModal, IdentificationDevice } from '../displays.state'

export interface IDisplaysToolbarContentDispatchProps {
    enableIdentificationAction: (devices: IdentificationDevice[]) => void
    disableIdentificationAction: (devices: IdentificationDevice[]) => void
    openModal: (data: IDisplaysModal) => void
}

export interface IDisplaysToolbarContentOwnProps {
    selectedInfo: ISelectedInfo
    online: boolean
    platform: string
    query: IRecordWithStrings
    parentId: number
    groupId: number
    downloadLink: string
    withoutAddress: { id: number; name: string }[]
    onCloseInfo: () => void
    selectedItems: ISelectedItems[]
}

export type IDisplaysToolbarContentProps = IDisplaysToolbarContentOwnProps & IDisplaysToolbarContentDispatchProps

type PowerModalTarget = '' | false | 'id' | 'groupId'
type SleepModeTarget = '' | 'digitalSignageId' | 'groupId'

interface IState {
    removeAll: boolean
    active: string[]
    modalState: boolean
    openPowerModal: PowerModalTarget
    sleepModeModal: SleepModeTarget
    externalStorages: {
        externalStorages: {
            size: {
                totalBytes: number
                usedBytes: number
                availableBytes: number
            }
            label: string
        }
        externalStoragesUpdatedAt: string
    } | null
    descriptionModal: {
        open: boolean
        text: string
    }
    isUpdatingScreenShot: boolean
    volume?: number
}

let itemId: number | null = null

const DisplaysToolbarContentMethods = (p_: IDisplaysToolbarContentProps) => {
    const [state, setState] = useState<IState>({
        removeAll: false,
        active: [],
        modalState: false,
        openPowerModal: '',
        sleepModeModal: '',
        externalStorages: null,
        descriptionModal: {
            open: false,
            text: '',
        },
        isUpdatingScreenShot: false,
    })

    let isGetVolume = true

    useEffect(() => {
        const listenersId: string[] = []

        api.addObserver(
            'digitalSignageScreenshotCreated',
            () => {
                setTimeout(() => {
                    setState((prevState) => ({ ...prevState, isUpdatingScreenShot: false }))
                }, 1000)
            },
            listenersId
        )

        if (p_.selectedInfo) {
            itemId = p_.selectedInfo.id
        }

        return () => listenersId.forEach((id) => api.removeObserver(id))
    }, [])

    useEffect(() => {
        if (!p_.selectedInfo) {
            return
        }

        setVolumeForDeviceOrGroup()
    }, [p_.selectedInfo])

    const enterSleepMode = (data: { digitalSignageId?: number; groupId?: number }, callback: () => void) => {
        if (!data.digitalSignageId && !data.groupId) return

        api.send('enterSleepMode', data).then(() => callback && callback())
    }

    const exitSleepMode = (data: { digitalSignageId?: number; groupId?: number }) => {
        if (!data.digitalSignageId && !data.groupId) return

        api.send('exitSleepMode', data)
    }

    const setVolumeForDeviceOrGroup = () => {
        if (p_.selectedInfo && p_.selectedInfo.id !== itemId) {
            isGetVolume = true
        }

        if (p_.selectedInfo.type === 'group' && isGetVolume) {
            isGetVolume = false

            getVolumeForGroup(p_).then((volume) => {
                if (state.volume !== volume) {
                    setState((prevState) => ({ ...prevState, volume }))
                }
            })
        }
    }

    const enableRefreshAnimation = () => {
        return setState((prevState) => ({ ...prevState, isUpdatingScreenShot: true }))
    }
    const getVolumeForGroup = async (p_: IDisplaysToolbarContentProps) => {
        return api
            .send<{ groupId: number }, { volume: number }>(
                'getGroupVolume',
                { groupId: p_.selectedInfo.id },
                { hideLoader: true }
            )
            .then((res) => res.volume)
    }

    // const handleClickOutside = () => {
    //
    //     if (!state.removeAll) {
    //         return
    //     }
    //
    //     setState(prevState => ({ ...prevState, removeAll: !state.removeAll }))
    // }

    const toggleRemoveAll = () => {
        setState((prevState) => ({ ...prevState, removeAll: !state.removeAll }))
    }

    const removeGroup = (groupItem: ISelectedInfo) => {
        api.send('deleteGroup', { id: groupItem.id, removeAll: state.removeAll })
        setState((prevState) => ({ ...prevState, showDeleteMenu: false }))
    }

    return {
        state,
        setState,
        enterSleepMode,
        enableRefreshAnimation,
        exitSleepMode,
        removeGroup,
        toggleRemoveAll,
    }
}

export default DisplaysToolbarContentMethods
